export default __webpack_public_path__ + "static/media/wallet white_new 1.149160e5.svg";